"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsertColumnBreakCommand = void 0;
var tslib_1 = require("tslib");
var control_1 = require("../../../core/model/options/control");
var rich_utils_1 = require("../../../core/model/rich-utils");
var command_base_1 = require("../command-base");
var command_states_1 = require("../command-states");
var InsertColumnBreakCommand = (function (_super) {
    tslib_1.__extends(InsertColumnBreakCommand, _super);
    function InsertColumnBreakCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InsertColumnBreakCommand.prototype.getState = function () {
        return new command_states_1.SimpleCommandState(this.isEnabled());
    };
    InsertColumnBreakCommand.prototype.isEnabled = function () {
        return _super.prototype.isEnabled.call(this) && control_1.ControlOptions.isEnabled(this.control.modelManager.richOptions.control.sections) &&
            this.selection.tableInfo.extendedData.numRows == 0 && this.selection.activeSubDocument.isMain();
    };
    InsertColumnBreakCommand.prototype.executeCore = function (_state, options) {
        this.insertTextWithSelection(options.intervalsInfo.subDocInterval, rich_utils_1.RichUtils.specialCharacters.ColumnBreak);
        return true;
    };
    return InsertColumnBreakCommand;
}(command_base_1.CommandBase));
exports.InsertColumnBreakCommand = InsertColumnBreakCommand;
